module.exports = __webpack_public_path__ + "static/foto-servicios-big-8d27bc3467f6269c1ba98a3d45b3ac02.jpg";